import RegisterView from './register'

const RegisterFreeBookView = RegisterView.extend({
    freeBook: true
})

export default RegisterFreeBookView